import { MutationTree } from 'vuex';
import { ApplicationUserState, initialState } from '@/store/modules/application-user/index';
import {
  APPLICATION_USER_RESET_STATE,
  SET_APPLICATION_USER_INFO_ERRORS,
  SET_APPLICATION_USER_LOADING,
  SET_APPLICATION_USER_SEARCH_OBJECT,
  SET_CHANGE_APP_USER_DETAILS_MODAL_ERRORS,
  SET_CURRENT_APP_USER_DETAILS,
  SET_OPEN_CHANGE_APP_USER_DETAILS_MODAL,
  SET_USER_ADDITIONAL_INFO_LIST,
  SET_USER_INFO_LIST,
} from '@/types/application-users.types';
import { ApplicationUserInfoModel } from '@/models/backoffice/ApplicationUserInfoModel';
import { Grid } from '@/models/Grid.model';
import { ApplicationUserAdditionalInfoModel } from '@/models/backoffice/ApplicationUserAdditionalInfoModel';
import { ApplicationUserSearchModel } from '@/models/backoffice/ApplicationUserSearchModel';
import { UserDetails } from '@/models/UserDetails.model';

export const mutations: MutationTree<ApplicationUserState> = {

  [SET_APPLICATION_USER_INFO_ERRORS]: (state, applicationUserInfoErrors: string[]) => {
    state.applicationUserInfoErrors = applicationUserInfoErrors;
  },

  [SET_APPLICATION_USER_LOADING]: (state, applicationUserLoading: boolean) => {
    state.applicationUserLoading = applicationUserLoading;
  },

  [SET_USER_INFO_LIST]: (state, userInfoList: Grid<ApplicationUserInfoModel>) => {
    state.userInfoList = userInfoList;
  },

  [SET_USER_ADDITIONAL_INFO_LIST]: (state, userAdditionalInfoList: Grid<ApplicationUserAdditionalInfoModel>) => {
    state.userAdditionalInfoList = userAdditionalInfoList;
  },

  [SET_APPLICATION_USER_SEARCH_OBJECT]: (state, applicationUserSearchObject: ApplicationUserSearchModel) => {
    state.applicationUserSearchObject = applicationUserSearchObject;
  },

  [SET_CURRENT_APP_USER_DETAILS]: (state, currentAppUserDetails: UserDetails) => {
    state.currentAppUserDetails = currentAppUserDetails;
  },

  [SET_OPEN_CHANGE_APP_USER_DETAILS_MODAL]: (state, openChangeAppUserDetailsModal: boolean) => {
    state.openChangeAppUserDetailsModal = openChangeAppUserDetailsModal;
  },

  [SET_CHANGE_APP_USER_DETAILS_MODAL_ERRORS]: (state, changeAppUserDetailsModalErrors: string[]) => {
    state.changeAppUserDetailsModalErrors = changeAppUserDetailsModalErrors;
  },

  [APPLICATION_USER_RESET_STATE]: (state) => {
    state = Object.assign(state, initialState());
  },
};
